export var VERTICAL_SPACING = 'S300';
export var MARKER_EXAMPLE_SIZE = 16;
export var defaultProps = {
  markers: []
};